/* ---------- 8. on-site activations: rich text → cards, desktop drag-scroll ---------- */

import { $, $$, clone, el } from '../lib/dom';
import { warn } from '../lib/log';

export const ACT = {
  list: 'e_what_list',
  card: 'e_what_card',
  img: 'e_what_img',
  text: 'e_what_card_text',
  trim: 'u-text-trim-off',
};
const ACT_TEXT = "h1, h2, h3, h4, h5, h6, p, em, [class*='u-text-style-']";

/** Every image in the rich text starts a card; everything until the next image is that card's text. */
export const renderActivations = () =>
  $$('[data-ewhat-content]').forEach((richText) => {
    if (richText.dataset.ewhatReady === 'true') return;
    let source: Element = richText; // Webflow sometimes nests all rich-text content in one extra wrapper — unwrap it
    for (
      let only = source.firstElementChild;
      only && source.children.length === 1 && $$('img', only).length > 1;
      only = source.firstElementChild
    )
      source = only;

    const cards: HTMLElement[] = [];
    let textWrap: HTMLElement | null = null;
    [...source.children].forEach((element) => {
      const image = element instanceof HTMLImageElement ? element : $<HTMLImageElement>('img', element);
      if (image) {
        Object.assign(image, { loading: 'lazy', decoding: 'async' });
        const img = clone(image);
        img.className = ACT.img;
        textWrap = el('div', ACT.text);
        const card = el('article', ACT.card);
        card.append(img, textWrap);
        cards.push(card);
        const rest = clone(element); // text sharing the image's wrapper is kept too
        $$('img, figure, .w-richtext-figure-type-image', rest).forEach((n) => n.remove());
        if (rest.textContent?.trim()) textWrap.append(...rest.children);
        return;
      }
      if (!textWrap) return;
      const copy = clone(element);
      [copy, ...$$(ACT_TEXT, copy)].forEach((n) => n.classList.add(ACT.trim));
      textWrap.append(copy);
    });

    if (!cards.length) return warn('activations: no cards detected', richText); // never wipe CMS content
    richText.replaceChildren(...cards);
    richText.classList.add(ACT.list);
    richText.dataset.ewhatReady = 'true';
  });

const DESKTOP = '(min-width: 992px)';
const DRAG_MIN_CARDS = 4;

/** Click-and-drag horizontal scrolling for card rows that overflow (desktop only). */
export const dragScroll = () => {
  if (!window.matchMedia(DESKTOP).matches) return;
  $$('.e_what_scroll').forEach((area) => {
    if ($$(`.${ACT.card}`, area).length <= DRAG_MIN_CARDS) return;
    area.classList.add('is-draggable');
    let dragging = false;
    let startX = 0;
    let startLeft = 0;
    const stop = () => {
      dragging = false;
      area.classList.remove('is-dragging');
    };
    area.addEventListener('mousedown', (e) => {
      if (e.button !== 0) return;
      dragging = true;
      startX = e.pageX;
      startLeft = area.scrollLeft;
      area.classList.add('is-dragging');
    });
    area.addEventListener('mousemove', (e) => {
      if (!dragging) return;
      e.preventDefault();
      area.scrollLeft = startLeft - (e.pageX - startX);
    });
    area.addEventListener('mouseleave', stop);
    window.addEventListener('mouseup', stop);
  });
};
